'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  padding: 2rem;\n'], ['\n  padding: 2rem;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

var PrivacyPolicy = function (_Component) {
  _inherits(PrivacyPolicy, _Component);

  function PrivacyPolicy() {
    _classCallCheck(this, PrivacyPolicy);

    return _possibleConstructorReturn(this, (PrivacyPolicy.__proto__ || Object.getPrototypeOf(PrivacyPolicy)).apply(this, arguments));
  }

  _createClass(PrivacyPolicy, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        Wrapper,
        null,
        _react2.default.createElement(
          'h1',
          null,
          'Privacy Policy'
        ),
        _react2.default.createElement(
          'strong',
          null,
          'Updated 1/14/2018'
        ),
        _react2.default.createElement(
          'p',
          null,
          'We understand your privacy is important to you, and we do our best to respect it as we hope others respect our own privacy.  The following describes what information we collect, why, and how we use it.'
        ),
        _react2.default.createElement(
          'h3',
          null,
          'Login Information'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The show provides services like a personalized showbag where you can save the show giveaways, brochures, coupons, etc.  To keep track of this information and allow you quick access across all your devices, we need to differentiate between people.  For this reason, to attend the show please create an account using your email, Twitter, Facebook, or Instagram.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The ',
          this.props.name,
          ' does not share this login information with any business, show exhibitor, or third party. Your email will only be used to reset your password (should you forget it), and to send you notices of future shows.  We dislike spam as much as you do, so we keep those notifications to a minimum.'
        ),
        _react2.default.createElement(
          'h3',
          null,
          'Show Survey'
        ),
        _react2.default.createElement(
          'p',
          null,
          'We ask some attendees to fill out a show survey for the purpose of improving our show for future attendees.  As a reward for participating, we offer a drawing for prizes among the participants.  Clearly, we need to contact you if you win  - so we ask in the survey for your email. If you choose not to include your contact info, your survey will be completely anonymous (but you will not be entered into the drawing).'
        ),
        _react2.default.createElement(
          'h3',
          null,
          'Show Exhibitors'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The ',
          this.props.name,
          ' provides links to exhibitor websites and resources outside of our show.  These are not covered by our privacy policy, but by those of the individual exhibitor.  Please consult their privacy policies for more information.'
        ),
        _react2.default.createElement(
          _reactRouterDom.Link,
          { to: '/' },
          'Back to the ',
          this.props.name
        )
      );
    }
  }]);

  return PrivacyPolicy;
}(_react.Component);

exports.default = PrivacyPolicy;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/privacy-policy/privacy-policy.js
// module id = 1096
// module chunks = 0